import * as React from 'react'
import './test-domain-overlay.scss'
import colorConvert from 'color-convert'
import classnames from 'classnames'

interface ITestDomainOverlayProps {
    label: string
    color: string
    icon: string | null
}

const TestDomainOverlay = React.memo(({ label, color, icon }: ITestDomainOverlayProps) => {
    const textColor = (colorConvert.hex.hsl(color)?.[2] ?? 0) > 70 ? 'black' : 'white'

    return (
        <div
            className={classnames('test-domain-overlay-composite', {
                'icon-missing': !icon,
            })}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="overlay"
                id="overlay"
                viewBox="0 0 400 400"
                width="64"
                height="64"
            >
                <polygon points="0 0 400 0 400 400 0 400" strokeWidth="30" stroke={color} fill="none" />

                <polygon points="0 0 300 0 0 300" strokeWidth="5" stroke={color} fill={color} />

                <text
                    fill={textColor}
                    fontSize="80"
                    fontWeight="900"
                    textAnchor="middle"
                    x="0"
                    y="200"
                    transform="rotate(-45)"
                >
                    {label}
                </text>
            </svg>

            {!icon ? (
                <div className="icon-missing-message">
                    <span>No Icon</span>
                </div>
            ) : (
                <img className="overlay-icon" src={icon} alt="Domain Icon" />
            )}
        </div>
    )
})

export default TestDomainOverlay
